import React from "react";
import "./CTA.scss";
import { Link } from "react-router-dom";
import { TitleBar } from "../Shapes/Shapes";

export const ViewPavers = () => {
  return (
    <div className="container-fluid">
      <div className="row justify-content-center panel-cta">
        <div className="col-10 col-sm-8 col-lg-4 text-center">
          <h2 className="text-uppercase text-blue">Get a free estimate</h2>
          <TitleBar />
          <Link to="/contact-us">
            <button className="button-main button-blue mt-4">
              Get My Estimate
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export const SpeakWithDesigner = ({ detailed }) => {
  return (
    <div className="container-fluid">
      <div className="row justify-content-center panel-cta">
        <div className="col-12 col-lg-6 text-center">
          <h2 className="text-uppercase text-blue">
            SOUTHERN CALIFORNIA'S #1 PAVER CONTRACTOR
          </h2>
          {detailed ? (
            <p>
              See what all of the buzz is about. Get your free estimate today.
            </p>
          ) : (
            ""
          )}
          <Link to="/contact-us">
            <button className="button-main button-blue mt-3">
              Get a Free Estimate
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export const ContactUs = () => {
  return (
    <div className="row justify-content-center panel-contact">
      <div className="col-9 col-md-8 col-lg-3 text-center">
        <h3 className="text-uppercase">Contact Us</h3>
      </div>
      <div className="col-12 text-center">
        <p className="mt-3">
          To speak to one of the team members, please call{" "}
          <strong>(818) 275-8613</strong>
        </p>
      </div>
    </div>
  );
};

export const LearnMore = () => {
  return (
    <div className="row justify-content-center panel-cta">
      <div className="col-10 col-sm-8 col-lg-6 text-center">
        <h2 className="text-uppercase text-blue">Learn More</h2>
        <a
          href="https://retailservices.wellsfargo.com/ahapp/init-app?m=0033000100&l=en_US"
          target="_black"
          rel="noreferrer"
        >
          <button className="button-main button-blue mt-3">
            Apply for Financing
          </button>
        </a>
      </div>
    </div>
  );
};
